import { defineMessages } from 'react-intl';

export default defineMessages({
	confirmationMessage: {
		id : 'twia.billing.directives.templates.payment-instruments.Confirmation Message',
		defaultMessage: 'Confirmation Message'
	 },
	 paymentConfirmation: {
		 id: 'twia.billing.directives.templates.payment-instruments.Success Header',
		 defaultMessage: 'Payment Confirmation'
	 },
	 ok:{
		id: 'twia.billing.directives.templates.payment-instruments.OK',
		defaultMessage: 'OK'
	 },
	 paymentSubmittedSuccessfully:{
		id: 'twia.policy.common.views.account-offer-details.Payment submitted successfully',
		defaultMessage: 'Payment submitted successfully.'
	 },
	 premiumPayment:{
		 id: 'twia.invoice.Premium Payment',
         defaultMessage: 'Premium Payment : {amount}'
	 },
	 vendorServiceFee:{
		id: 'twia.invoice.Vendor Service Fee',
		defaultMessage: 'Vendor Service Fee: {feeAmount}'
	 },
	 totalPayment: {
		id: 'twia.invoice.Total Payment',
		defaultMessage: 'Total Payment: {amount}'
	 },
	 confirmation: {
        id: 'twia.makepaymentconfirmation.Confirmation #',
        defaultMessage: 'Confirmation #: {confirmationNumber}'
    },
});